import { UNIT } from "../../constants/configuration";
import { CSSProperties } from "react";
import { getColors } from "../../utils";

const getStyles = () => {
  return {
    addressInput: {
      fontSize: UNIT * 0.875,
      width: "84%",
      border: 0,
      borderRadius: UNIT * 2,
      marginLeft: UNIT * 1.5,
      textIndent: 0,
    } as CSSProperties,

    btn: {
      borderRadius: UNIT * 2,
      width: " 100%",
    } as CSSProperties,

    space: {
      marginBottom: UNIT * 0.125,
      fontSize: "large",
      marginRight: UNIT * 0.25,
    } as CSSProperties,

    menuStyle: {
      width: "100%",
      backgroundColor: "transparent!important",
      color: "black!important",
      padding: "5px 13px",
      justifyContent: "space-between",
    } as CSSProperties,

    inputText: {
      fontSize: UNIT * 0.875,
      marginLeft: UNIT * 0.5,
    } as CSSProperties,

    startIcon: {
      fontSize: "large",
    } as CSSProperties,

    formControlLabel: {
      fontSize: UNIT * 0.875,
      fontWeight: 400,
      marginBottom: -UNIT * 0.5,
      width: "100%",
    } as CSSProperties,

    labelStyle: {
      fontSize: UNIT * 0.8125,
      color: "gray",
      paddingLeft: "0.7rem",
      marginTop: -UNIT * 0.9375,
      marginBottom: UNIT * 0.5,
    } as CSSProperties,

    truncText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "90%",
    } as CSSProperties,

    row: {
      alignItems: "center",
      flexDirection: "row",
      display: "flex",
    } as CSSProperties,

    errorText: {
      color: "red",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontWeight: 500,
      padding: "var(--Spacing-Spacing-8, 8px) 0px",
    } as CSSProperties,

    suggestionsPaper: {
      top: "100%",
      left: 0,
      width: "100%",
      zIndex: 1300,
      mt: "4px",
      p: 0,
      borderRadius: 1,
      maxHeight: 150,
      overflow: "auto",
      marginTop: "8px",
      scrollbarWidth: "none" as const,
      msOverflowStyle: "none" as const,
    } as CSSProperties,

    bottomNavigation: {
      flex: 1,
      maxWidth: "none",
      padding: 0,
      alignItems: "stretch",
      "& .MuiBottomNavigationAction-wrapper": {
        width: "100%",
        height: "100%",
      },
    } as CSSProperties,

    loadingContainer: {
      height: 80,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    } as CSSProperties,

    choicesContainer: {
      display: "flex",
      padding: "0px 0px 10px 0px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      flex: "1 0 0",
      alignSelf: "stretch",
      maxHeight: 170,
      overflow: "auto" as const,
    } as CSSProperties,
    welcomeTitle: {
      display: "flex",
      flex: "1 0 0",
      overflow: "hidden",
    },
    bottomNavigationContainer: {
      display: "flex",
      padding: "8px 0px",
      alignItems: "flex-end",
      gap: "8px",
      alignSelf: "stretch",
      height: "auto",
    },
    title: {
      display: "flex",
      padding: "var(--Spacing-Spacing-20, 20px) 0px",
      alignItems: "center",
      gap: "16px",
      alignSelf: "stretch",
    },
    addressContainer: {
      display: "flex",
      padding: "var(--Spacing-Spacing-8, 8px) 0px",
      flexDirection: "column",
      alignItems: "flex-start",
      alignSelf: "stretch",
    } as CSSProperties,
    label: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontWeight: 500,
    },
    footer: {
      display: "flex",
      padding: "var(--Spacing-Spacing-24, 24px) 0px",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "var(--Spacing-Spacing-16, 16px)",
      borderTop: getColors().border,
      flexShrink: 0,
      height: "96px",
    },
    containerSx: {
      padding: "8px 0px",
    },

    radioLabelWrapperSx: {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
    },
    radioContentSx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      width: "100%",
    },

    textContainerSx: {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      px: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: 1,
    },

    descriptionStackSx: {
      mt: 0.5,
      overflow: "hidden",
      color: getColors().description,
    },

    descriptionTextSx: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    }
  };
}
export default getStyles;
